// 课程api

import { baseRequest, fileUploadRequest } from './base'

import store from '../vuex'

import utils from '../utils'

import Vue from 'vue'

/**
 * @desc 查询课程列表
 */
function getCourseList_all(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaCourse/'
  return baseRequest(tempUrl, 'get', params)
}

function getProCourseList(params){
  // 清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaCourse/initTeaCourse'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 查询课程列表
 */
function getCourseList(params) {
  //如果选择了学校，加入学校字段
  if (Vue.ls.get('schoolId')) {
    params = params ? params : {}
    params.schoolId = Vue.ls.get('schoolId')
  }

  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/pcWeb/teaCourse/'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 下拉课程列表
 */
function getselectCourseOffering(params) {
  //如果选择了学校，加入学校字段
  if (Vue.ls.get('schoolId')) {
    params = params ? params : {}
    params.schoolId = Vue.ls.get('schoolId')
  }
  params.courseName = ''
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/courseRecommend/selectCourseOffering'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 根据课程ID获取课程信息
 */
function getCourseById(id) {
  return baseRequest(`/api/pcWeb/teaCourse/${id}`, 'get')
}

/**
 * @desc 新增课程
 */
function addCourse(params) {
  //如果有价格乘以100
  if (params) {
    if (params.coursePrice) {
      params.coursePrice = utils.common.accMul(params.coursePrice, 100)
    }
    if (params.textbookPrice) {
      params.textbookPrice = utils.common.accMul(params.textbookPrice, 100)
    }
    if (params.totalPrice) {
      params.totalPrice = utils.common.accMul(params.totalPrice, 100)
    }
    if (params.unitPrice) {
      params.unitPrice = utils.common.accMul(params.unitPrice, 100)
    }
  }
  params = utils.common.checkNull(params)
  return baseRequest(`/api/pcWeb/teaCourse/create`, 'post', params)
}

/**
 * @desc 审核课程
 */
function check(id, params) {
  return baseRequest(`/api/pcWeb/teaCourse/check/${id}`, 'post', params)
}

/**
 * @desc 删除课程
 */
function deleteCourse(id) {
  return baseRequest(`/api/pcWeb/teaCourse/delete/${id}`, 'get')
}

/**
 * @desc 修改课程
 */
function updateCourse(id, params) {
  //如果有价格乘以100
  if (params) {
    if (params.coursePrice) {
      params.coursePrice = utils.common.accMul(params.coursePrice, 100)
    }
    if (params.textbookPrice) {
      params.textbookPrice = utils.common.accMul(params.textbookPrice, 100)
    }
    if (params.totalPrice) {
      params.totalPrice = utils.common.accMul(params.totalPrice, 100)
    }
    if (params.unitPrice) {
      params.unitPrice = utils.common.accMul(params.unitPrice, 100)
    }
  }
  //清除空白字段
  params = utils.common.checkNull(params)
  return baseRequest(`/api/pcWeb/teaCourse/update/${id}`, 'post', params)
}

/**
 * @desc 下拉搜索平台课程
 */
function selectSearch(params) {
  let tempUrl = '/api/pcWeb/teaCourse/selectSearch'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 开班所选的的课程列表
 */
function listClassCourse(params) {
  let tempUrl = '/api/pcWeb/teaCourse/listClassCourse'
  return baseRequest(tempUrl, 'get', params)
}

// 评价-课节评价列表
/**
 * @desc 开班所选的的课程列表
 */
function LessonEvaluation(params) {
  let tempUrl = '/api/teaScheduleEvaluation/list'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 课程-加入选课或移除选课
 */
function selectOrRemove(params) {
  return baseRequest(`/api/pcWeb/teaCourse/selectOrRemove`, 'post', params)
}

/**
 * @desc 导出课程
 */
function exportCourse(params) {
  return fileUploadRequest(`/api/pcWeb/teaCourse/exportCourse`, params)
}

// 添加推荐课程
function Recommendsave(params) {
  //如果选择了学校，加入学校字段
  if (store.getters.schoolId) {
    // params = params ? params : {};
    params.schoolId = store.getters.schoolId
  }

  return baseRequest('/api/courseRecommend/save', 'post', params)
}
// 推荐课程列表
function Recommendlist(params) {
  let tempUrl = '/api/courseRecommend/list'
  return baseRequest(tempUrl, 'get', params)
}
// 课程提供方
function courseSourceSelect(params) {
  let tempUrl = 'api/pcWeb/teaCourse/courseSourceSelect'
  return baseRequest(tempUrl, 'get', params)
}

/**
 * @desc 课程提交审核
 */
function submitCourse(params) {
  return baseRequest(
    `/api/pcWeb/teaCourse/submittingCheckCourse`,
    'post',
    params
  )
}
/**
 * @desc 查询课程列表
 */
function Recommendlist_all(params) {
  //清除空白字段
  params = utils.common.checkNull(params)
  let tempUrl = '/api/courseRecommend/list'
  if (Vue.ls.get('schoolId')) {
    params.schoolId = Vue.ls.get('schoolId')
  }
  return baseRequest(tempUrl, 'get', params)
}

// 删除推荐
function deleteRecommend(id) {
  return baseRequest(`/api/courseRecommend/delete/${id}`, 'get')
}

// 修改推荐课程
function updateRecommend(params) {
  return baseRequest(`/api/courseRecommend/update`, 'post', params)
}

// 审核详情
function getCheckOperateLog(courseId) {
  return baseRequest(
    `/api/pcWeb/teaCourse/getCheckOperateLog/${courseId}`,
    'get'
  )
}

// 修改课程提示
function modifyCourse(flag) {
  return baseRequest(`api/pcWeb/teaCourse/getTipInfo/${flag}`, 'get')
}

export default {
  updateRecommend: updateRecommend,
  deleteRecommend: deleteRecommend,
  Recommendsave: Recommendsave,
  Recommendlist: Recommendlist,
  getCourseList: getCourseList,
  Recommendlist_all: Recommendlist_all,
  getCourseList_all: getCourseList_all,
  getCourseById: getCourseById,
  addCourse: addCourse,
  deleteCourse: deleteCourse,
  updateCourse: updateCourse,
  check: check,
  selectSearch: selectSearch,
  listClassCourse: listClassCourse,
  selectOrRemove: selectOrRemove,
  exportCourse: exportCourse,
  getselectCourseOffering: getselectCourseOffering,
  submitCourse,
  getCheckOperateLog,
  modifyCourse,
  courseSourceSelect,
  LessonEvaluation,
  getProCourseList
}
